export enum ComparisonOperators {
  Equal = '===',
  NotEqual = '!==',
  GreaterThan = '>',
  GreaterThanOrEqual = '>=',
  LessThan = '<',
  LessThanOrEqual = '<=',
  Includes = 'includes',
  NotIncludes = '!includes',
  NotEmpty = '!empty',
}
